import React, { ChangeEvent, FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useI18n } from 'i18n';
import Input from 'components/molecules/input';
import { DEFAULT_SET_VALUE_PROPS } from 'constants/form';
import { IMonitoringAssetForm } from 'types/vehicles-monitoring';

import styles from './styles.module.css';

interface IRippleIdFieldProps {
  isLoading: boolean;
}

export const RippleIdField: FC<IRippleIdFieldProps> = ({ isLoading }) => {
  const { fc } = useI18n();

  const { control, formState, setValue } = useFormContext<IMonitoringAssetForm>();

  const error = formState.errors.id?.message;

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue('id', event.target.value.replaceAll(' ', '-'), DEFAULT_SET_VALUE_PROPS);
  };

  return (
    <Controller
      control={control}
      name="id"
      rules={{ required: fc('please enter the Ripple ID') }}
      render={({ value }) => (
        <Input
          className={styles.input}
          label={fc('ripple ID')}
          readOnly={isLoading}
          required
          error={error}
          value={value}
          onChange={onChange}
        />
      )}
    />
  );
};
